import { render, staticRenderFns } from "./DialogAuth.vue?vue&type=template&id=f9b985a4&scoped=true&"
import script from "./DialogAuth.vue?vue&type=script&lang=js&"
export * from "./DialogAuth.vue?vue&type=script&lang=js&"
import style0 from "./DialogAuth.vue?vue&type=style&index=0&id=f9b985a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b985a4",
  null
  
)

export default component.exports